<template>
  <Dialog
    :show='confirmer.active'
    :okText='confirmer.okText'
    :cancelText='confirmer.cancelText'
    :title='confirmer.title'
    @cancel='confirmer.resolve(false)'
    @validate='confirmer.resolve(true)'
  >
    <span class='message'>
      {{ confirmer.message }}
    </span>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog'
export default {

  name: 'Confirm',

  components: {
    Dialog
  },

  computed: {
    confirmer () {
      return this.$store.state.confirm
    }
  }
}
</script>
